import { Button, Image } from "antd";
import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import DeleteIconRed from "../../../assets/icons/DeleteIconRed";
import XIcon from "../../../assets/icons/XIcon";
import Avatar from "../../../assets/images/avatar.svg";
import {
  useDeleteAllChatMutation,
  useGetChatAttachmentsQuery,
} from "../../../features/superAdmin/ticketService/ticketServiceApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";
import CollapseItems from "./CollapseItems";

type SingChatInfoType = {
  name?: string;
  img?: string;
  id?: string;
};

export default function SingChatInfo({
  setShowInfo,
  chatDetails,
}: {
  setShowInfo: any;
  chatDetails?: SingChatInfoType;
}) {
  const [searchParams] = useSearchParams();
  const chatId = searchParams.get("chatId");
  const auth = useAppSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  const isGroupChat = location?.pathname?.split("/")?.includes("group");

  const {
    isLoading: isGetAttachmentLoading,
    isError: isGetAttachmentError,
    error: getAttachmentError,
    data: getAttachmentData,
  } = useGetChatAttachmentsQuery(
    {
      id: chatId,
      params: {
        userId: chatDetails?.id,
      },
    },
    {
      skip: !chatId || isGroupChat,
    },
  );

  const [
    deleteAllChat,
    {
      isLoading: deleteAllChatIsLoading,
      isError: deleteAllChatIsError,
      error: deleteAllChatError,
      isSuccess: deleteAllChatIsSuccess,
    },
  ] = useDeleteAllChatMutation();

  useError(
    isGetAttachmentError,
    getAttachmentError,
    "Get group attachment list fail",
  );
  useError(deleteAllChatIsError, deleteAllChatError, "Delete all chat fail");

  useEffect(() => {
    let basePath = "/user/communication/message";
    if (auth?.role === "super_admin" || auth?.role === "Admin") {
      basePath = "/admin/communication/message";
    }
    if (deleteAllChatIsSuccess) {
      toast("success", "All chat deleted ssuccessfully!");
      navigate(basePath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAllChatIsSuccess]);

  return (
    <div className="border !border-[#cccccc] rounded-md p-3 overflow-y-auto h-full">
      <div className="flex justify-between items-center">
        <span className="text-lg">User Info</span>
        <span className="cursor-pointer" onClick={setShowInfo}>
          <XIcon />
        </span>
      </div>

      <div className="flex justify-center mt-4">
        <Image
          src={chatDetails?.img || Avatar}
          className="rounded-full object-cover"
          alt="..."
          width={80}
          height={80}
        />
      </div>
      <div className="flex justify-center gap-2 items-center text-lg mt-4">
        <span>{chatDetails?.name}</span>
      </div>

      <div className="text-base font-medium my-4">Shared Files</div>
      <CollapseItems
        isLoading={isGetAttachmentLoading}
        data={getAttachmentData?.data}
      />

      <Button
        className="flex items-center text-[#FF3838] bg-[#FFF5F4] border-[#FFA19B] justify-center py-3"
        block
        loading={deleteAllChatIsLoading}
        onClick={() => {
          deleteAllChat({
            id: chatId,
            data: {
              userId: auth.user?.id,
            },
          });
        }}
      >
        <DeleteIconRed /> <span className="ml-1">Delete Chat</span>
      </Button>
    </div>
  );
}
